
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 140 140","height":"140","width":"140","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M87.5 100.625v13.125a8.75 8.75 0 01-8.75 8.75h-17.5a8.75 8.75 0 01-8.75-8.75v-13.125M70 4.375v8.75M8.75 65.625h8.75M21.875 21.875l6.417 6.166M131.25 65.625h-8.75M118.125 21.875l-6.417 6.166M52.004 100.625h35.992a38.5 38.5 0 0021.379-35A40.093 40.093 0 0070 26.25a40.093 40.093 0 00-39.375 39.398 38.5 38.5 0 0021.38 34.977zM70 122.5v13.125M70 78.75v21.875","stroke-width":"8.749995"}}),_c('path',{attrs:{"d":"M56.875 65.625L70 78.75l13.125-13.125","stroke-width":"8.749995"}})])])
          )
        }
      }
    